import axioscommon from './axios-common';
import authHeader from './auth-header';

const defaultSettings = require('@/settings.js');
const API_URL = defaultSettings.apiUrl + '/api/issues/';

class IssueService {
    getAllIssues() {
        return axioscommon.get(API_URL, { headers: authHeader() });
    }
    getAllIssuesFullData() {
        return axioscommon.get(API_URL + 'fulldata/', { headers: authHeader() });
    }
    getIssuesByDate(type, from, to) {
        return axioscommon.get(API_URL + 'getbydate/' + type + '/' + from + '/' + to, { headers: authHeader() });
    }
    getIssuesByDateCustomMailing(type, from, to) {
        return axioscommon.get(API_URL + 'getcustom/' + type + '/' + from + '/' + to, { headers: authHeader() });
    }
    getActiveIssues() {
        return axioscommon.get(API_URL + 'active/', { headers: authHeader() });
    }
    getPerformantIssues() {
        return axioscommon.get(API_URL + 'activePerformant', { headers: authHeader() });
    }
    getPaginatedIssues(data) {
        return axioscommon.get(API_URL + 'page?' + data, { headers: authHeader() });
    }
    getData(id) {
        return axioscommon.get(API_URL + 'fulldata/' + id, { headers: authHeader() });
    }
    searchIssues(query) {
        return axioscommon.get(API_URL + 'search/' + query, { headers: authHeader() });
    }
    updateIssue(id, data) {
        return axioscommon.put(API_URL + id, data, { headers: authHeader() });
    }
    changeCustomer(id, idCustomer) {
        return axioscommon.put(API_URL + 'changecustomer/' + id + '/' + idCustomer, null, { headers: authHeader() });
    }
    removeIssue(id) {
        return axioscommon.delete(API_URL + id, { headers: authHeader() });
    }
    reactivateIssue(id) {
        return axioscommon.put(API_URL + 'activate/' + id, null, { headers: authHeader() });
    }
    // permaKillIssue(id) {
    //     return axioscommon.delete(API_URL + 'forceremoval/' + id, { headers: authHeader() });
    // }
    getMyTickets(id) {
        return axioscommon.get(API_URL + 'myIssue/' + id, { headers: authHeader() });
    }
    getMyTicketCustomer(email) {
        return axioscommon.get(API_URL + 'myTicket/' + email, { headers: authHeader() });
    }
    getCustomerTickets(id) {
        return axioscommon.get(API_URL + 'customerIssue/' + id, { headers: authHeader() });
    }
    getIssuesBySerial(serial) {
        return axioscommon.get(API_URL + 'serial/' + serial, { headers: authHeader() });
    }
    saveIssue(data) {
        return axioscommon.post(API_URL, data, { headers: authHeader() });
    }
    sendMail(data, type) {
        return axioscommon.post(API_URL + 'mail/' + type, data, { headers: authHeader() });
    }
}

export default new IssueService();
